<script>

    import { toast } from 'bulma-toast'
    import { createEventDispatcher } from 'svelte'
    import { chargesStore, chargeStore, modalStore, adminStore, notifyStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import ChargesService from '../$services/charges.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Button from '../$components/button.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let approving = false

    async function approveCharge() {

        approving = true
        const resp = await ChargesService.approveCharge($chargeStore._id)
        approving = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargeStore.set(resp.data)
        chargesStore.replace(resp.data)

        if(resp.data.status === 'paid') {
            toast({message: 'Cargo aprobado y cobrado', type: 'is-success'})
            notifyStore.set('wallet_updated')
        } else {
            toast({message: 'Cargo aprobado, pendiente de saldo', type: 'is-warning'})
        }
    }

    async function deleteCharge() {

        loading = true
        const resp = await ChargesService.deleteCharge($chargeStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.remove($chargeStore._id)

        toast({message: 'Cargo borrado', type: 'is-success'})
        notifyStore.set('wallet_updated')
        dispatch('delete')
        modalStore.close()
    }

</script>

<InfoCard subtitle="Cargo">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        {#if $chargeStore.admin?.name}
            <InfoField label="Admin" icon="fas fa-user-shield" value={ $chargeStore.admin.name } />
            <InfoField label="Correo admin" icon="fas fa-envelope" value={ $chargeStore.admin.email } />
        {/if}
        <InfoField label="Estatus" icon="fas fa-info-circle" value={ TranslateMethods.get($chargeStore.status) } />
        <InfoField label="Tipo" icon="fas fa-tag" value={ TranslateMethods.get($chargeStore.type) } />
        <InfoField label="Método" icon="fas fa-wallet" value={ TranslateMethods.get($chargeStore.method) } />
        <InfoField label="Monto" icon="fas fa-dollar-sign" value={ NumeralMethods.cash($chargeStore.amount) } bold />
        <InfoField label="Concepto" icon="fas fa-align-left" value={ $chargeStore.concept } size="full" />
        <InfoField label="Detalles" icon="fas fa-info-circle" value={ $chargeStore.details } size="full" />
        {#if $chargeStore.shipment?.created}
            <InfoField label="Guía" icon="fas fa-barcode" value={ $chargeStore.shipment.guide } />
        {/if}
        {#if $chargeStore.updated != $chargeStore.created}
            <InfoField label="Fecha de pago" icon="far fa-calendar-check" value={ DateMethods.dateTimeLarge($chargeStore.updated) } />
        {/if}
        <InfoField label="Fecha de registro" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($chargeStore.created) } />
    </div>
</InfoCard>

<div class="items-end">
    <div class="buttons">
        {#if isPermission($adminStore, 'UsersView.Charge.Delete')}
            {#if $chargeStore.status === 'review'}
                <Button text="Aprobar cargo" icon="check" color="primary" loading={ approving } on:click={ approveCharge } />
            {/if}
            <ButtonDelete on:confirm={deleteCharge} { loading } />
        {/if}
        {#if isPermission($adminStore, 'UsersView.Charge.Update')}
            <ButtonModal modalId="charge_update_modal" icon="edit" text="Actualizar" />
        {/if}
    </div>
</div>
